import { keepPreviousData } from '@tanstack/react-query';
import { useGlobalQuery } from '@/state/query-client/hooks';
import {
  getBasicInfoCtcLevels,
  getBasicInfoDepartments,
  searchReportingManagers,
} from '../services/basic-info-lookups.service';
import { CtcLevelOption } from '../types/basic-info-lookups.types';
import { DepartmentLookupOption, ManagerOption } from '../types/employee.types';

export const useGetBasicInfoDepartments = () =>
  useGlobalQuery<DepartmentLookupOption[]>({
    queryKey: ['hr-basic-info-departments'],
    queryFn: getBasicInfoDepartments,
    staleTime: 10 * 60 * 1000,
  });

export const useGetBasicInfoCtcLevels = () =>
  useGlobalQuery<CtcLevelOption[]>({
    queryKey: ['hr-basic-info-ctc-levels'],
    queryFn: getBasicInfoCtcLevels,
    staleTime: 30 * 60 * 1000,
  });

export const useSearchReportingManagers = (keyword: string) =>
  useGlobalQuery<ManagerOption[]>({
    queryKey: ['hr-basic-info-managers', keyword],
    queryFn: () => searchReportingManagers(keyword),
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
  });
